<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<main role="main">
    <h2 *ngIf="!isCancellationError" id="title-error">{{ 'error.title' | translate }}</h2>
    <h2 *ngIf="isCancellationError" id="title-error-cancel">{{ 'cancellation.title' | translate }}</h2>
    <section class="infoBox">
        <p [hidden]="info()" id="general-error-info">{{ 'error.description' | translate }}</p>
        <p [hidden]="!info()" id="reason-error-info">{{ reason | translate }}</p>
    </section>
    <section [hidden]="!(existsSession() || existsSubscriberErrorPage())">
        <form class="content">
            <div class="centeredContainer">
                <div class="centered">
                    <fieldset id="gallery">
                        <div class="item" [hidden]="!existsSession()">
                            <p>{{ 'confirmError.return.text' | translate }}</p>
                            <br/> <span class="centeredContainer"> <a
                                (click)="back()" class="k-button floatNone">{{
                            'confirmError.return' | translate }}</a>
						</span> <br/> <br/>
                        </div>
                        &nbsp;
                        <div class="item" [hidden]="!existsSubscriberErrorPage()">
                            <p>{{ 'confirmError.confirm.text' | translate }}</p>
                            <br/> <span class="centeredContainer"> <a
                                (click)="exit()" class="k-button floatNone">{{
                            'confirmError.confirm' | translate }}</a>
						</span> <br/> <br/>
                        </div>
                        <br class="clear"/>
                    </fieldset>
                </div>
            </div>
        </form>
    </section>
</main>